import React from 'react'

import TextField from '@mui/material/TextField'

interface TextInputProps {
  label: string
  value: string
  isRequired?: boolean
  isDisabled?: boolean
  autoFocus?: boolean
  errorMessage?: string
  multiline?: boolean
  onChange: (newValue: string) => void
}

const TextInput = (props: TextInputProps) => {
  return (
    <TextField
      label={props.label}
      required={props.isRequired}
      disabled={props.isDisabled}
      autoFocus={props.autoFocus}
      multiline={props.multiline}
      minRows={4.15}
      value={props.value}
      error={!!props.errorMessage}
      helperText={props.errorMessage}
      inputProps={{ maxLength: props.multiline ? 2047 : 255 }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event.target.value)
      }}
    />
  )
}

export default TextInput
